import { CSSProperties } from '@material-ui/core/styles/withStyles';
import { palette, paletteDark } from './palette';
import type { ThemeType } from './themeHelpers';

export interface FocusOutlineOptions {
  position?: 'inset' | number;
  colorInside?: string;
  colorOutside?: string;
}

const getPalette = (themeType: ThemeType) => {
  /**
   * When running unit tests, always return the direct palette.
   * This avoids needing to provide a theme provider on each render.
   */
  if (process.env.NODE_ENV === 'test') {
    return palette;
  }

  if (typeof themeType === 'string') {
    return themeType === 'light' ? palette : paletteDark;
  }

  return themeType.palette;
};

export const focusOutline = (theme: ThemeType, options?: FocusOutlineOptions): CSSProperties => {
  const palette = getPalette(theme);
  const colorIn = options?.colorInside ?? palette.focus.light;
  const colorOut = options?.colorOutside ?? palette.focus.main;
  let offset = -1;

  if (options && typeof options.position === 'number') {
    offset = options.position;
  } else if (options && options.position === 'inset') {
    offset = 1;
  }

  return {
    '&::before': {
      content: '""',
      position: 'absolute',
      top: offset,
      left: offset,
      right: offset,
      bottom: offset,
      borderRadius: 'inherit',
      boxShadow: `0 0 0 1px ${colorIn}, 0 0 0 2px ${colorOut}, 0 0 0 3px #fff`,
      // Needed for high contrast mode
      border: `2px solid ${palette.highContrastOnly.main}`,
    },
  };
};
